export class BulkRestoreRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "items",
            "baseName": "items",
            "type": "Array<BulkRestoreItem>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BulkRestoreRequest.attributeTypeMap;
    }
    constructor() {
    }
}
